import React, { useEffect, useState } from "react";
import "./MissingVariantsChecker.css";

function MissingVariantsChecker() {
  const [missingVariants, setMissingVariants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const checkMissingVariants = async () => {
      const serverUrl = "https://api.malidag.com";

      try {
        const response = await fetch(`${serverUrl}/check-variants`);

        if (!response.ok) {
          throw new Error("Error fetching missing variants");
        }

        const data = await response.json();

        if (data.missingVariants && data.missingVariants.length > 0) {
          setMissingVariants(data.missingVariants);
        } else {
          setMissingVariants([]);
        }
      } catch (err) {
        console.error("Error checking missing variants:", err);
        setError("Unable to load missing variants right now.");
      } finally {
        setLoading(false);
      }
    };

    checkMissingVariants();
  }, []);

  return (
    <div className="missing-variants">
      <div className="missing-variants__header">
        <h3 className="missing-variants__title">Missing Variants Checker</h3>
        <p className="missing-variants__subtitle">
          Review folders that are missing <strong>images-variants</strong>.
        </p>
      </div>

      {loading && (
        <div className="missing-variants__state missing-variants__state--neutral">
          <p>Loading missing variants...</p>
        </div>
      )}

      {!loading && error && (
        <div className="missing-variants__state missing-variants__state--error">
          <p>{error}</p>
        </div>
      )}

      {!loading && !error && missingVariants.length > 0 && (
        <div className="missing-variants__state missing-variants__state--warning">
          <h4>Warning: Missing Variants Found</h4>
          <p>
            The following folders are missing <strong>images-variants</strong>:
          </p>

          <ul className="missing-variants__list">
            {missingVariants.map((folderId) => (
              <li key={folderId} className="missing-variants__item">
                {folderId}
              </li>
            ))}
          </ul>

          <p className="missing-variants__note">
            Please add <strong>images-variants</strong> for these folders.
          </p>
        </div>
      )}

      {!loading && !error && missingVariants.length === 0 && (
        <div className="missing-variants__state missing-variants__state--success">
          <p>All folders have images-variants.</p>
        </div>
      )}
    </div>
  );
}

export default MissingVariantsChecker;